<template>
    <div>
        <b-breadcrumb :items="items"/>
        <div class="container-fluid">
            <!--            <span style="color: red">**ถ้าหากต้องการเปลี่ยนรายละเอียดชีท ในกรณีที่มีชีทซ้ำกัน ให้เปลี่ยนข้อมูลเฉพาะตัวที่อยู่ล่างสุด</span>-->
            <br/>
            <b-button class="float-right mb-2" @click="showAddModal" variant="success">
                <icon name="save" style="width: 25px"></icon>
                เพิ่มเม็ดสี
            </b-button>
            <table width="100%">
                <thead>
                <tr>
                    <th width="5%">เครื่อง</th>
                    <th width="4%">เวลาที่เริ่มผลิต</th>
                    <!--                    <th width="5%">รหัสชีท</th>-->
                    <th width="7%">ชีท</th>
                    <th width="5%">จำนวน</th>
                    <th width="8%">วันที่เริ่มผลิต</th>
                    <th width="5%">ช่วง</th>
                    <!--                    <th width="5%">กลุ่ม</th>-->
                    <th width="15%">รายละเอียดชีท</th>
                    <th width="5%">เม็ด</th>
                    <th width="3%">เก่า</th>
                    <th width="3%">ใหม่</th>
                    <th width="4%">แป้ง</th>
                    <th width="6%">ลบ</th>
                    <!--                    <th width="5%">หมายเหตุ</th>-->
                </tr>
                </thead>
                <tbody>
                <template v-for="(data,i) in sheet_report">
                    <tr>
                        <td>
                            <multiselect
                                v-model="data.machine"
                                :show-labels="false"
                                :options="optionMachine"
                                label="name"
                                placeholder="เครื่องผลิต"
                                track-by="name">
                            </multiselect>
                        </td>
                        <td>
                            <input type="time" class="form-control w-100" v-model="data.start_time"/>
                        </td>
                        <td>
                            <multiselect
                                v-model="data.sheet"
                                :show-labels="false"
                                :options="optionSheet"
                                :custom-label="sheetCodeWithName"
                                placeholder="เลือกชีท"
                                @input="setCodeSheet(data.sheet)"
                                track-by="name">
                            </multiselect>
                        </td>
                        <td>
                            <input
                                v-model="data.quantity"
                                placeholder="ม้วน"
                                type="number"
                                class="form-control"/>
                        </td>
                        <td>
                            <date-picker
                                v-model="data.start_date"
                                type="date"
                                class="w-100"
                                :format="changeFormat"
                                :lang="lang"
                                placeholder="วันที่ผลิต">
                            </date-picker>
                        </td>
                        <td>
                            <b-form-select
                                v-model="data.work_start"
                                :options="optionShift">
                            </b-form-select>
                        </td>
                        <!--                    <td>-->
                        <!--                        <b-form-select-->
                        <!--                            v-model="data.group_id"-->
                        <!--                            :options="Group">-->
                        <!--                        </b-form-select>-->
                        <!--                    </td>-->
                        <td v-if="data.sheet" class="row">
                            <div class="text-left col-6">
                                กว้าง :
                                <input type="number" class="form-control"
                                       v-model="data.sheet.width"/>
                            </div>
                            <div class="text-left col-6">
                                ยาว :
                                <input type="number" class="form-control"
                                       v-model="data.sheet.length"/>
                            </div>
                            <div class="text-left col-6">
                                ความหนา :
                                <input type="text" class="form-control"
                                       v-model="data.sheet.thickness"/>
                            </div>
                            <div class="text-left col-6">
                                น้ำหนัก :
                                <input type="number" class="form-control"
                                       v-model="data.sheet.weight"/>
                            </div>
                            <!--                        <div  class="text-left col-6">-->
                            <!--                            ขอบ :-->
                            <!--                            <input type="number" class="form-control"-->
                            <!--                                   v-model="data.sheet.border"/>-->
                            <!--                        </div>-->
                            <div class="text-left col-6">
                                เส้นผ่านศูนย์กลาง :
                                <input type="text" class="form-control"
                                       v-model="data.sheet.diameter"/>
                            </div>
                        </td>
                        <td v-else>

                        </td>
                        <td>
                            <multiselect
                                class="only_grain"
                                v-model="data.grain"
                                :show-labels="false"
                                :options="optionMaterial"
                                label="name"
                                placeholder="เม็ด"
                                track-by="id">
                            </multiselect>
                        </td>
                        <td>
                            <input type="text" class="form-control"
                                   v-model="data.grain_old"/>
                        </td>
                        <td>
                            <input type="text" class="form-control"
                                   v-model="data.grain_new"/>
                        </td>
                        <td>
                            <input type="text" class="form-control"
                                   v-model="data.flour"/>
                        </td>
                        <td>
                            <b-button type="button"
                                      class="btn btn-success"
                                      @click.once="saveSheetReport">
                                <icon name="save" style="width: 25px"></icon>
                                บันทึก
                            </b-button>
                            <br/>
                            <button type="button"
                                    class="btn btn-danger"
                                    @click="deleteIndex(data.id)">
                                <icon name="trash-alt" style="width: 25px"></icon>
                                ลบ
                            </button>
                        </td>
                    </tr>
                    <tr v-if="i != sheet_report.length-1">
                        <td colspan="15">
                            <hr/>
                        </td>
                    </tr>
                </template>
                </tbody>
            </table>
        </div>
        <div class="container-fluid">
            <br/>
            <div class="col text-center">
                <b-button variant="success"
                          @click="addSheetReport">
                    <icon name="save" style="width: 25px"></icon>
                    เพิ่มเครื่อง
                </b-button>
                &nbsp;&nbsp;
                <b-button variant="success"
                          @click.once="saveSheetReport">
                    <icon name="save" style="width: 25px"></icon>
                    บันทึก
                </b-button>
                &nbsp;&nbsp;
                <b-button class="btn btn-secondary"
                          @click="goToSheetReportList">
                    <icon name="times" style="width: 25px"></icon>
                    ยกเลิก
                </b-button>
            </div>
            <br/>
        </div>
        <!-- ----Modal Delete---- -->
        <b-modal hide-header hide-footer ref="delete_item">
            <div style="text-align: center;">
                <h4>คุณต้องการลบข้อมูลใช่ไหม?</h4>
                <br/>
                <button
                    type="button"
                    class="btn btn-success"
                    @click="deleteSheetReport">
                    ตกลง
                </button>
                &nbsp;&nbsp;
                <button
                    type="button"
                    class="btn btn-outline-secondary"
                    @click="hideModalDelete">
                    ยกเลิก
                </button>
            </div>
        </b-modal>
        <b-modal hide-header hide-footer ref="add_modal">
            <div style="text-align: center;">
                <div class="row">
                    <div class="col-3 text-right">รหัสวัตถุดิบ</div>
                    <div class="col-8">
                        <input placeholder="เช่น MT001"
                               type="text"
                               class="form-control"
                               v-model="add.code"/>
                    </div>
                </div>
                <br>
                <div class="row">
                    <div class="col-3 text-right">รายการวัตถุดิบ</div>
                    <div class="col-8">
                        <input placeholder="เช่น เม็ดโฟม"
                               type="text"
                               class="form-control"
                               v-model="add.name"/>
                    </div>
                </div>
                <br>
                <div class="row">
                    <div class="col-3 text-right">รายการวัตถุดิบ</div>
                    <div class="col-8">
                        <b-form-select v-model="add.unit"
                                       :options="unitOption">
                        </b-form-select>
                    </div>
                </div>
                <br>
                <div class="row">
                    <div class="col-3 text-right">จำนวนขั้นต่ำ</div>
                    <div class="col-8">
                        <input
                            type="number"
                            class="form-control"
                            v-model="add.min_quantity"/>
                    </div>
                </div>
                <br/>
                <button
                    type="button"
                    class="btn btn-success"
                    @click.once="AddMaterial">
                    ตกลง
                </button>
                &nbsp&nbsp
                <button
                    type="button"
                    class="btn btn-outline-secondary"
                    @click="hideAddModal">
                    ยกเลิก
                </button>
            </div>
        </b-modal>
        <!--<pre class="alert-primary">{{optionMaterial.length}}</pre>-->
    </div>
</template>

<script>
import HeaderTitle from "../../HeaderTitle";
import {mapState} from "vuex";
import Multiselect from "vue-multiselect";
import moment from "moment";
import DatePicker from 'vue2-datepicker'

export default {
    components: {HeaderTitle, Multiselect, DatePicker},
    name: "sheet-report-information",
    props: {
        id: {default: null}
    },
    data() {
        return {
            optionMaterial: [],
            items: [
                {
                    text: "รายงานการผลิตชีท",
                    to: {name: "sheet-report"}
                },
                {
                    text: "เพิ่มเติม",
                    active: true
                }
            ],
            Group: [
                {value: null, text: "เลือกกะ"},
                {value: 1, text: "กะ A"},
                {value: 2, text: "กะ B"}
            ],
            changeFormat: {
                stringify: (date) => {
                    let date_moment = moment(date).format('YYYY');
                    const year = parseInt(date_moment) + 543;
                    //console.log(moment(date).format('DD/MM/'+year));
                    return date ? moment(date).format('DD/MM/' + year) : null
                },
                parse: (value) => {
                    return value ? moment(value, 'DD/MM/YYYY').subtract(543, 'y').toDate() : null
                }
            },
            lang: {
                days: ['อา', 'จ', 'อ', 'พ', 'พฤ', 'ศ', 'ส'],
                months: ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'],
                pickers: ['ถัดไป 7 วัน', 'ถัดไป 30 วัน', 'ก่อนหน้า 7 วัน', 'ก่อนหน้า 30 วัน'],
                placeholder: {
                    date: 'วว/ดด/ปปปป',
                }
            },
            add: {
                'code': '',
                'name': '',
                'unit': '',
                'min_quantity': '',
            },
            unitOption: [
                {
                    value: "",
                    text: "เลือกหน่วย"
                },
                {
                    value: "kg",
                    text: "kg"
                },
                {
                    value: "ใบ",
                    text: "ใบ"
                },
                {
                    value: "กระปุก",
                    text: "กระปุก"
                },
                {
                    value: "แกลอน",
                    text: "แกลอน"
                },
                {
                    value: "ปิ๊บ",
                    text: "ปิ๊บ"
                },
                {
                    value: "ม้วน",
                    text: "ม้วน"
                },
                {
                    value: "โหล",
                    text: "โหล"
                },
                {
                    value: "ลัง",
                    text: "ลัง"
                },
                {
                    value: "มัด",
                    text: "มัด"
                },
            ],
        };
    },
    created() {
        if (!this.id) {
            this.$store.dispatch("ReportSheet/clearFormData");
        }
        // this.$store.dispatch("Machine/getMachineSheet");
        // this.$store.dispatch('ReportSheet/clearFormData')
        this.$store.dispatch("Sheet/getAll");
        this.$store.dispatch('Common/setShiftWork');
        this.getMaterialAll();
    },
    computed: {
        ...mapState({
            form: state => {
                return state.ReportSheet.Form;
            },
            sheet_report: state => {
                return state.ReportSheet.table;
            },
            optionMachine: state => {
                return state.Machine.machine_sheet;
            },
            optionSheet: state => {
                return state.Sheet.sheet_all;
            },
            user: state => {
                return state.Auth.user;
            },
            optionShift: state => {
                return [
                    {
                        value: null,
                        text: "กรุณาเลือกกะ"
                    },
                    ...state.Common.shift_work.map(shift => ({
                        value: shift.id,
                        text: shift.name
                    }))
                ];
            },
            is_create: state => {
                return state.ReportSheet.is_create;
            },
        }),
    },
    methods: {
        deleteIndex(id) {
            if (confirm('ลบการผลิต')) {
                this.$store.dispatch('ReportSheet/removeList', id).then(() => {
                    // if (this.sheet_report.length > 0){
                    //     this.$store.dispatch("ReportSheet/show", this.sheet_report[0].id).then(() => {
                    //         this.$router.push({
                    //             name: "sheet-report-information",
                    //             params: { id }
                    //         });
                    //     });
                    // }else{
                    //     this.$router.push({
                    //         name: "sheet-report",
                    //     });
                    // }
                })
            }
        },
        showModalDelete() {
            this.$refs.delete_item.show();
        },
        hideModalDelete() {
            this.$refs.delete_item.hide();
        },
        showAddModal() {
            this.$refs.add_modal.show();
        },
        hideAddModal() {
            this.$refs.add_modal.hide();
        },
        AddMaterial() {
            this.$store.dispatch('Material/addMeterial', this.add).then(() => {
                this.add = {
                    'code': '',
                    'name': '',
                    'unit': '',
                    'min_quantity': '',
                }
                this.hideAddModal();
                this.getMaterialAll();
            })
        },
        getMaterialAll() {
            this.$store.dispatch("Material/getAll").then(res => {
                this.optionMaterial = res.filter(material => material.type == 3)
            });
        },
        addSheetReport() {
            this.sheet_report.push({
                id: null,
                sheet_code: "",
                sheet_id: "",
                machine_id: "",
                quantity: "",
                start_date: "",
                start_time: "",
                work_start: null,
                end_date: "",
                end_time: "",
                work_end: null,
                date: "",
                reason: "",
                machine: null,
                sheet: null,
                user: this.user.name,
                grain: null,
                grain_id: "",
                grain_new: "",
                grain_old: "",
                flour: "",
                problem: "",
                group_id: null,
                is_delete: null,
            })

        },
        saveSheetReport() {
            let counter = 0;
            this.sheet_report.forEach(data => {
                if (data.machine) {
                    data.machine_id = data.machine.id;
                } else {
                    alert("กรุณาเลือกเครื่อง");
                    counter++;
                }
                if (data.sheet) {
                    data.sheet_id = data.sheet.id;
                }
                // else{
                //     alert("กรุณาเลือกชีทที่ผลิต")
                //     counter++;
                // }
                if (data.grain) {
                    data.grain_id = data.grain.id;
                }
                if (data.start_date) {
                    data.start_date = moment(data.start_date).format("YYYY-MM-DD");
                }
                if (data.end_date) {
                    data.end_date = moment(data.end_date).format("YYYY-MM-DD");
                }
                // if(data.quantity < 0){
                //     alert("กรุณาใส่จำนวนให้ถูกต้อง")
                //     counter++;
                // }
                // if(!data.group_id){
                //     alert("กรุณาเลือกกลุ่ม")
                //     counter++;
                // }
            })
            if (counter == 0 && !this.is_create) {
                return this.$store.dispatch("ReportSheet/save", this.sheet_report).then(() => {
                    this.goToSheetReportList();
                });
            } else if (counter == 0 && this.is_create) {
                return this.$store.dispatch("ReportSheet/saveNew", this.sheet_report).then(() => {
                    //console.log(this.sheet_report)
                    this.goToSheetReportList();
                });
            }
        },
        deleteSheetReport() {
            this.$store.dispatch("ReportSheet/delete", this.id).then(() => {
                this.hideModalDelete();
                this.goToSheetReportList();
            });
        },
        goToSheetReportList() {
            this.$router.push({
                name: "sheet-report"
            });
        },
        setCodeSheet(data) {
            if (data) {
                this.form.sheet_code = data.code;
            } else {
                this.form.sheet_code = ""
            }
        },
        sheetCodeWithName({code, name}) {
            return `${name} - ${code}`
        },
    }
};
</script>
<style>
.only_grain .multiselect__content-wrapper {
    width: fit-content;
}
</style>

<style scoped>
.form-button {
    /*margin-left: 20%;*/
    display: flex;
    padding: 0;
}

</style>
